export enum ContentType {
  Trilha,
  Subdivisao,
}
